import actions from './actions';
import mutations from './mutations';

export default {
  state: {
    userOrganizations: [],
    userOrganization: {},
    userOrganizationsTotalCount: 0,
    roles: [],
    createdByUserList: [],
  },
  mutations,
  actions,
  getters: {
    getUsers: (state) => state.createdByUserList,
  },
};
